import classNames from 'classnames';
import * as React from 'react';

import { getTranslation, keys } from '../../../../../Resources/Translations';
import { Loader } from '../../../../Components/Loader/Loader';
import { getFor } from '../../../../ReactComponents/API';
import { InvoiceAvailabilityStatus } from '../../../Dynamics/Invoices/ViewModel/InvoiceAvailabilityStatus.csharp';
import { InvoiceAvailabilityViewModel } from '../../../Dynamics/Invoices/ViewModel/InvoiceAvailabilityViewModel.csharp';

interface OrderDetailsInvoicesProps {
    invoices: string[];
    orderId: string;
    availabilityUrl: string;
    downloadUrl: string;
}

interface OrderDetailsInvoicesState {
    invoices: InvoiceStatus[];
}

export class OrderDetailsInvoices extends React.Component<OrderDetailsInvoicesProps, OrderDetailsInvoicesState> {
    constructor(props: OrderDetailsInvoicesProps) {
        super(props);

        this.state = {
            invoices:
                props.invoices?.map((invoiceId) => {
                    return { id: invoiceId, name: '', status: null };
                }) || []
        };
    }

    componentDidMount() {
        const fetchInvoiceStatus = (invoiceId: string) => {
            const url = this.props.availabilityUrl.transformUrl({
                orderId: this.props.orderId,
                invoiceId: invoiceId
            });
            getFor<InvoiceAvailabilityViewModel>(`/${url}`)
                .then((result) => {
                    this.updateInvoiceStatus(invoiceId, result.invoiceName, result.status);
                })
                .catch(() => {
                    this.updateInvoiceStatus(invoiceId, '', InvoiceAvailabilityStatus.UnexpectedError);
                });
        };

        this.state.invoices && this.state.invoices.map((invoice) => fetchInvoiceStatus(invoice.id));
    }

    render() {
        return (
            <div className="OrderDetails__Invoices">
                {this.state.invoices?.map((invoice, i) => (
                    <div key={invoice.id} className="OrderDetails__Invoice">
                        <a className={this.getButtonClassNames(invoice)} target="_blank" href={this.getDownloadUrl(invoice)} rel="noreferrer">
                            {getTranslation(keys['orderSummary.invoices.invoice'])} {i + 1}
                            {invoice.status === null && (
                                <span className="OrderDetails__InvoiceLoader">
                                    <Loader isLoading />
                                </span>
                            )}
                        </a>
                        {invoice.status === InvoiceAvailabilityStatus.NotReady && (
                            <span className="OrderDetails__InvoiceMessage">{getTranslation(keys['orderSummary.invoices.notReady'])}</span>
                        )}
                        {invoice.status === InvoiceAvailabilityStatus.UnexpectedError && (
                            <span className="OrderDetails__InvoiceMessage">{getTranslation(keys['orderSummary.invoices.unavailable'])}</span>
                        )}
                    </div>
                ))}
            </div>
        );
    }

    private getButtonClassNames = (invoice: InvoiceStatus) => {
        return classNames('OrderDetails__InvoiceButton', invoice.status === null && 'OrderDetails__InvoiceButton--Loading');
    };

    private getDownloadUrl = (invoice: InvoiceStatus) => {
        if (invoice.status === InvoiceAvailabilityStatus.Available) {
            return `/${this.props.downloadUrl.transformUrl({
                orderId: this.props.orderId,
                invoiceId: invoice.id,
                fileName: invoice.name
            })}`;
        }

        return undefined;
    };

    private updateInvoiceStatus = (invoiceId: string, invoiceName: string, status: InvoiceAvailabilityStatus) => {
        this.setState((prevState) => {
            return {
                invoices: prevState.invoices.map((invoice) => {
                    return invoice.id === invoiceId ? { ...invoice, name: invoiceName, status: status } : invoice;
                })
            };
        });
    };
}

interface InvoiceStatus {
    id: string;
    name: string;
    status: InvoiceAvailabilityStatus | null;
}
